<template>
    <card-dashboard 
        id="card-liberacoes-pendentes"
        bg-variante="warning" 
        titulo="" 
        :valor="valor"
        titulo-modal="Liberações pendentes"
        :colunas="colunas"
        :dados="dados"
    >
        <template #titulo>
            <span>
                Liberações<br/>pendentes
            </span>
        </template>
    </card-dashboard>
</template>
<script>
import CardDashboard from "@/components/card/CardDashboard";
import DashboardAdminService from "@/common/services/dashboards/dashboard_admin.service";
export default {
    components : {
        CardDashboard
    },
    mounted(){
        this.buscarDados();
    },
    data : () => ({
        valor : 0,
        colunas : [
            { key : "text", label : "Usuário"}
        ],
        dados : [],
    }),
    methods : {
        buscarDados(){
            DashboardAdminService.liberacoesPendentes().then(response => {
                this.dados = response.data.data.map(el => {
                    return {
                        text : el
                    }
                });
                this.valor = response.data.data.length;
            });
        }
    }
    
}
</script>
<style lang="">
    
</style>